module.exports = __webpack_public_path__ + "img/@ico_heart.85be5016.png";